function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.576 10.566L6.72 9.328l2.272 2.697-.795.46a1.663 1.663 0 01-1.704-.025c-1.591-.98-2.89-2.344-3.9-4.09-1.008-1.748-1.54-3.555-1.592-5.423a1.663 1.663 0 01.83-1.488L2.627 1l1.2 3.316-2.143 1.238",
  stroke: "currentColor",
  strokeLinecap: "round"
})));